














import { UserRole } from '@/resource/user/user.model';
import { getRole } from '@/utils/cookie';
import { Component, Vue } from 'vue-property-decorator';
import QuestionUploadStore, {
  QuestionUploadStoreInterface,
} from '@/resource/question-upload/question-upload.store';
import UploadQuestionContainer from '@/components/upload-questions/UploadQuestionContainer.vue';

@Component({
  components: {
    UploadQuestionContainer,
  },
})
export default class UploadQuestions extends Vue {
  isLoading = true;
  uploadQuestionStore: QuestionUploadStoreInterface = QuestionUploadStore;

  get userRole(): UserRole | null {
    return getRole();
  }

  get uploadQuestions() {
    return this.uploadQuestionStore.questionUploads;
  }

  async fetchUploadQuestions() {
    this.isLoading = true;
    await this.uploadQuestionStore.fetchQuestionUploads();
    this.isLoading = false;
  }

  async created() {
    await this.fetchUploadQuestions();
  }
}
